<script>
    import {Component, Vue} from 'nuxt-property-decorator'
    import HotelMap from '@/components/search/offers/HotelMap'
    import TourMapInfoWindow from '@/components/tours/search/offers/TourMapInfoWindow.vue'

    @Component()
    export default class TourMap extends HotelMap {
        async load() {
            await this.initMap()
        }

        addMarker(offer) {
            let position
            if (offer.coordinates) {
                position = {
                    lat: offer.coordinates[0],
                    lng: offer.coordinates[1],
                }
            } else {
                return
            }

            if (this.markers.findIndex(marker => marker.position === position) !== -1) return

            //if (this.markers.find(marker => position === marker.position)) return;
            const marker = new this.google.maps.Marker({
                position,
                icon: this.createMarkerIcon(offer),
                data: offer,
                minPrice: 0,
            })

            marker.addListener('click', () => {
                if (!marker.infoWindow) {
                    this.showInfoWindow(marker)
                }
            })

            this.markers.push(marker)
            return marker
        }

        showInfoWindow(marker) {
            const markerWithInfoWindow = this.markers.find(marker => marker.infoWindow)
            if (markerWithInfoWindow) {
                markerWithInfoWindow.infoWindow.close()
                markerWithInfoWindow.infoWindow = null
            }
            const InfoWindowComponent = Vue.extend(TourMapInfoWindow)
            const instance = new InfoWindowComponent({
                propsData: {
                    offer: marker.data,
                    withLink: this.linkToHotels,
                },
                parent: this,
            })
            instance.$mount()
            marker.infoWindow = new this.google.maps.InfoWindow({
                content: instance.$el,
            })
            this.google.maps.event.addListener(marker.infoWindow, 'closeclick', () => {
                marker.infoWindow.close()
                marker.infoWindow = null
            })
            marker.infoWindow.open(this.map, marker)
        }

        setMapPosition() {
            this.map.fitBounds(this.bounds)
            this.mapPositionInit = true
        }

        saveMapPosition() {}
    }
</script>
